import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { getAdminDetailsStart } from "../../../../store/redux-slices/staffSlice"

export const useEditStaff = () => {
  const dispatch = useDispatch()
  const { adminUserId } = useParams()
  const { adminDetails, loading } = useSelector(state => state.staff)

  useEffect(() => {
    dispatch(getAdminDetailsStart({ adminUserId }))
  }, [adminUserId])

  // Helper function to get original phone number
  const getOriginalPhone = () => {
    if (!adminDetails?.phone) return null
    return adminDetails.phone
  }

  // Helper function to get original phone parts
  const getOriginalPhoneParts = () => {
    if (!adminDetails?.phone) return { phoneCode: '', phone: '' }
    const parts = adminDetails.phone.split(' ')
    return {
      phoneCode: parts[0] || '',
      phone: parts[1] || ''
    }
  }

  return {
    staffDetails: adminDetails,
    loading,
    getOriginalPhone,
    getOriginalPhoneParts
  }
}
